<div class="load-more-container" *ngIf="!state.isLastPage">
    <button class="load-more-btn" (click)="loadMore()"
    [disabled]="state.isLastPage" [ngClass]="{'disabled': state.isLastPage}" >Load more {{loadMoreLabel}}</button>
    <ul class="navigation flex-container" *ngIf="localAppService?.loadMoreListing">
        <ng-container *ngFor="let elt of navigation; let i = index">
            <li class="navigation-dot" id="dot-{{i}}" [ngClass]="{'disabled': state.isLastPage}"></li>
        </ng-container>
    </ul>
</div>